import { render, staticRenderFns } from "./NotificationAppointment.vue?vue&type=template&id=0b6b7f51&scoped=true"
import script from "./NotificationAppointment.vue?vue&type=script&lang=js"
export * from "./NotificationAppointment.vue?vue&type=script&lang=js"
import style0 from "./NotificationAppointment.vue?vue&type=style&index=0&id=0b6b7f51&prod&scoped=true&lang=css"
import style1 from "./NotificationAppointment.vue?vue&type=style&index=1&id=0b6b7f51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b7f51",
  null
  
)

export default component.exports